import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-35160ffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { buildLineAreaStyle, ECHARTS_LINE_COLOR, getAssignLineOption, withLineSeriesStyle } from '@/utils/echarts-option/line'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import TimeRangeSelect from '@/views/dashboard/_components/time-range-select/time-range-select.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { getElColorPrimary, getElColorPrimaryRgba } from '@/utils/theme-color'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'

interface ChartData {
  times: string[]
  counts: number[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'popup-intercept-trend-chart',
  props: {
    data: { default: () => ({
    times: [],
    counts: []
  }) },
    timeRange: { default: TimeRange.DAYS_30 }
  },
  emits: ["update:timeRange"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const localTimeRange = computed({
  get: () => props.timeRange,
  set: (value) => emit('update:timeRange', value)
})


const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)

const chartData = computed(() => props.data)
const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

const chartOption = computed(() => {
  if (!chartData.value?.times?.length) {
    return { xAxis: { data: [] }, series: [] }
  }

  return {
    xAxis: {
      data: chartData.value.times,
    },
    series: [withLineSeriesStyle({
      name: '弹窗拦截次数',
      data: chartData.value.counts,
      areaStyle: buildLineAreaStyle(ECHARTS_LINE_COLOR.blue),
      smooth: true,
      type: 'line',
    }, ECHARTS_LINE_COLOR.blue)]
  }
})

function initChart () {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
  renderChart()
}

function renderChart () {
  if (!chartInstance) return
  const finalOption: any = getAssignLineOption(chartOption.value, { unit: '次' })
  chartInstance.setOption(finalOption)
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance && chartInstance.resize()
})

watch(() => chartData.value, () => {
  if (!chartData.value?.times?.length) return
  if (!chartInstance) {
    nextTick(initChart)
  } else {
    renderChart()
  }
}, { deep: true })

useEchartsThemeSync(renderChart)

onMounted(() => {
  if (chartData.value?.times?.length) {
    nextTick(initChart)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance && chartInstance.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: '广告弹窗拦截趋势',
    class: "popup-intercept-trend-chart-wrap"
  }, {
    headerRight: _withCtx(() => [
      _createVNode(TimeRangeSelect, {
        modelValue: localTimeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localTimeRange).value = $event)),
        width: 120
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "chart-wrapper"
        }, null, 512)
      ], 512), [
        [_vShow, chartData.value?.times?.length]
      ]),
      _withDirectives(_createVNode(EmptyData, {
        height: "292px",
        "bg-color": "transparent"
      }, null, 512), [
        [_vShow, !chartData.value?.times?.length]
      ])
    ]),
    _: 1
  }))
}
}

})